import { createEntityQuery } from '../../createEntityQuery';
import {
  TransferAllocateSharedService,
  type Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto,
} from '@wealthlane/api-services/wealthlane-award-service';

export type TransferAndAllocateTransactionDetailDto =
  Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateTransactionDetailDto;

const useTransferAndAllocateQuery = createEntityQuery<TransferAndAllocateTransactionDetailDto, string>(
  {
    queryKey: ['transferAndAllocateByTransactionId'],
    queryFn: (transactionId) =>
      TransferAllocateSharedService.getApiAwardApiAppTransferAllocateTransferAllocateDetailByTransactionId(
        transactionId!,
      ),
    silent: true,
  },
);

/**
 * Transfer-and-allocate detail by transaction ID.
 * Shared across award types (Options, SAR, etc.).
 * SAR transaction tab: pass `intentTransactionId ?? transactionId` as the effective ID.
 */
export function useGetTransferAndAllocateByTransactionId(
  transactionId: string | undefined,
  enabled = true,
) {
  return useTransferAndAllocateQuery(transactionId as string, {
    enabled: Boolean(transactionId) && enabled,
  });
}
